import { ProgCss } from "./ProgCss.Generated";
import { cast } from "./tools";

export function BuildDevColorSwatch(scopeEl: HTMLElement) {
    for (const hostEl of scopeEl.querySelectorAll(`.${ProgCss.DevColorSwatch}`)) {
        const circlesEl = hostEl.getElementsByClassName(ProgCss.DevColorSwatch_circles)[0];

        const minLightnessEl = cast(hostEl.querySelector("[data-DevColorSwatch-filter=minL]"), HTMLInputElement);
        const maxLightnessEl = cast(hostEl.querySelector("[data-DevColorSwatch-filter=maxL]"), HTMLInputElement);
        const minChromaEl = cast(hostEl.querySelector("[data-DevColorSwatch-filter=minC]"), HTMLInputElement);
        const maxChromaEl = cast(hostEl.querySelector("[data-DevColorSwatch-filter=maxC]"), HTMLInputElement);
        const minHueEl = cast(hostEl.querySelector("[data-DevColorSwatch-filter=minH]"), HTMLInputElement);
        const maxHueEl = cast(hostEl.querySelector("[data-DevColorSwatch-filter=maxH]"), HTMLInputElement);
        const sortEls = [...hostEl.querySelectorAll("input[name=DevColorSwatch_sort]")].map(o => cast(o, HTMLInputElement));

        const computedStyle = getComputedStyle(hostEl);

        const colors = [...document.styleSheets[0].cssRules]
            .filter(rule => rule instanceof CSSStyleRule)
            .flatMap(rule => [...rule.style]
                .map(propertyName => ({ propertyName, propertyValue: rule.style.getPropertyValue(propertyName) }))
            ).filter(o => o.propertyName.startsWith('--color') && computedStyle.getPropertyValue(o.propertyName))
            .map(o => {
                const colorBlockElement = document.createElement("div");
                colorBlockElement.className = ProgCss.DevColorSwatch_colorBlock;

                const colorBlockCircleElement = document.createElement("div");
                colorBlockCircleElement.className = ProgCss.DevColorSwatch_colorCircle;
                colorBlockCircleElement.style.color = `var(${o.propertyName})`;

                const propertyNameEl = document.createElement("b");
                propertyNameEl.classList.add(ProgCss.DevColorSwatch_textLine);
                propertyNameEl.append(o.propertyName);

                const isOkLch = /^oklch\(.*\)$/.test(o.propertyValue);
                const propertyValue = isOkLch
                    ? o.propertyValue.substring(6, o.propertyValue.length - 1)
                    : o.propertyValue;
                const propertyValueEl = document.createElement("div");
                propertyValueEl.classList.add(ProgCss.DevColorSwatch_textLine);
                if (!isOkLch) {
                    propertyValueEl.classList.add(ProgCss.u_error);
                }
                propertyValueEl.append(propertyValue);
                propertyValueEl.title = propertyValue;

                const colorBlockTextElement = document.createElement("div");
                colorBlockTextElement.append(propertyNameEl, propertyValueEl);

                colorBlockElement.append(colorBlockCircleElement, colorBlockTextElement);
                circlesEl.append(colorBlockElement);
                return { ...o, colorBlockElement, colorBlockCircleElement };
            }).map(o => {
                const computedColor = getComputedStyle(o.colorBlockCircleElement).color;
                const components = [...computedColor.matchAll(/\d*[\.\d]\d*/g)].flat().map(parseFloat);
                const space = computedColor.match(/^[^(]*/g)?.[0] || "";
                if (components.length > 3) {
                    o.colorBlockCircleElement.classList.add(ProgCss.DevColorSwatch_colorCircle__hasTransparency);
                }
                return { ...o, components, space };
            });


        hostEl.addEventListener("input", e => {
            if (e.target instanceof HTMLElement && (e.target.classList.contains(ProgCss.DevColorSwatch_semiTransToggle)
                || e.target.classList.contains(ProgCss.DevColorSwatch_singleColumnMode))) {
                return;
            }
            const sortOrder = sortEls.filter(el => el.checked)[0].value;
            const sortOrderIdx = parseFloat(sortOrder);

            const minLightness = minLightnessEl.valueAsNumber;
            const maxLightness = maxLightnessEl.valueAsNumber;
            const minChroma = minChromaEl.valueAsNumber;
            const maxChroma = maxChromaEl.valueAsNumber;
            const minHue = minHueEl.valueAsNumber;
            const maxHue = maxHueEl.valueAsNumber;

            const filtered = colors.filter(o => true
                && (isNaN(minLightness) || minLightness <= o.components[0])
                && (isNaN(maxLightness) || maxLightness >= o.components[0])
                && (isNaN(minChroma) || minChroma <= o.components[1])
                && (isNaN(maxChroma) || maxChroma >= o.components[1])
                && (!isNaN(minHue) && !isNaN(maxHue) && maxHue < minHue
                    ? o.components[2] <= minHue || maxHue <= o.components[2] // cylindrical dimension
                    : (isNaN(minHue) || minHue <= o.components[2])
                    && (isNaN(maxHue) || maxHue >= o.components[2]))
            );

            const inOrder = sortOrder === "alpha"
                ? filtered.toSorted((a, b) => (a.propertyName.localeCompare(b.propertyName)))
                : sortOrder === "orig"
                    ? filtered
                    : filtered.toSorted((a, b) => (a.components[sortOrderIdx] - b.components[sortOrderIdx]));

            circlesEl.replaceChildren(...inOrder.map(o => o.colorBlockElement));
        });
    }
}
